export const catIdRedirect = {
    url: 'http://www.jcpenney.com/women/dresses/cat.jump?id=cat100210008',
    pattern: new RegExp(/\/cat.jump/i),
    apiPath: 'j/seourl',
};
